import { isProductType } from '@motionelements/core/src/services/catalog.service';

export default {
  computed: {
    title() {
      // code copied from ProductTitle.vue
      return this.element.name;
    },
    isElement() {
      return this.element.object === 'element';
    },
    isCollection() {
      return this.element.object === 'collection';
    },
    collectionItemCount() {
      if (!this.isCollection) {
        return null;
      }
      return _.get(this.element, 'items.totalCount', _.get(this.element, 'items.total_count'));
    },
    name() {
      return _.get(this.element, 'name') || '';
    },
    videoUrl() {
      if (this.isCollection) {
        return null;
      }
      const videoUrl = _.get(this.element, 'thumbnails.mp4.url') || _.get(this.element, 'previews.mp4.url');
      // just in case, check if is mp4
      if (!videoUrl || videoUrl.lastIndexOf('.mp4') === -1) {
        return null;
      }
      return videoUrl;
    },
    showStaticPreview() {
      if (this.isCollection) {
        return true;
      }
      return !(isProductType('image', this.mediaType) || isProductType('3d_model', this.mediaType));
    },
    thumbnails() {
      return _.get(this.element, 'thumbnails.jpgs', []);
    },
    isAudio() {
      if (this.isCollection) {
        return false;
      }
      return isProductType('audio', this.mediaType);
    },
    hasSample() {
      return _.get(this.element, 'sample', false);
    },
  },
};
